var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1121 14.0828L9.21481 10.6911C8.73951 10.3578 8.73951 9.65781 9.21481 9.33281L14.1121 5.93281C14.6808 5.54948 15.4531 5.94115 15.4531 6.61615V13.3995C15.4531 14.0745 14.6808 14.4661 14.1121 14.0828ZM6.96562 5.84115V14.1745C6.96562 14.6328 6.58368 15.0078 6.11687 15.0078C5.65005 15.0078 5.26812 14.6328 5.26812 14.1745V5.84115C5.26812 5.38281 5.65005 5.00781 6.11687 5.00781C6.58368 5.00781 6.96562 5.38281 6.96562 5.84115Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackword);
export default __webpack_public_path__ + "static/media/Backword.5f0249d8d6938c24fc3bfb1ab9b27829.svg";
export { ForwardRef as ReactComponent };